import { LocationQuestionConfig } from '@gripp/shared-logic';
import { useTranslation } from 'react-i18next';
import { InlineFields, LabelledSlot } from '../components/printPrimitives';
import { RoutinePrintQuestion } from './types';

export const LocationPrintQuestion: RoutinePrintQuestion = ({ config }) => {
  const location = config as LocationQuestionConfig;
  const { t } = useTranslation();

  return (
    <InlineFields>
      <LabelledSlot label={t('routine.print.location', 'Location')} grow={2} />
      {location.includeMemo ? (
        <LabelledSlot label={t('routine.print.memo', 'Memo')} grow={2} />
      ) : null}
    </InlineFields>
  );
};
